// @flow
import React from "react";
import styled, { css } from "styled-components";
import RawMoney from "../../../Money";
import HowMuchInBucks from "../../../HowMuchInBucks";
import * as Icons from "../../../Icons/Tournaments";

import type { Node } from "react";

const Wrapper = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  padding: 5px 0;
`;

const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 5px 0;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: ${({ theme }) => theme.tournamentCardMainColor};
`;

const Fund = styled.div`
  font-weight: 400;

  ${({ theme }) =>
    theme.direction === "rtl"
      ? css`
          margin-right: 8px;
          text-align: right;
        `
      : css`
          margin-left: 8px;
          text-align: left;
        `};
`;

const Money = styled(RawMoney)`
  font-weight: 700;
`;

const Currency = styled(RawMoney.Symbol)`
  color: ${({ theme }) => theme.alternativeAccent};
`;

type Props = {
  children: Node,
  prize_fund_usd: string,
  prize_fund: string
};

function PrizeFund({ children, prize_fund_usd, prize_fund }: Props) {
  return (
    <Wrapper>
      {children}
      <Container>
        <Icons.Cup width="16px" height="20px" />
        <Fund>
          <HowMuchInBucks
            value={prize_fund}
            valueUSD={prize_fund_usd}
            symbolStyle={Currency}
            moneyStyle={Money}
          />
        </Fund>
      </Container>
    </Wrapper>
  );
}

export default PrizeFund;



// WEBPACK FOOTER //
// ./src/components/Tournaments/Account/Card/PrizeFund.js